import React from 'react';
import {
  Skeleton,
} from '@mui/material';
import { BackButton, OutlinedIcons } from '@marageti/z4-lib';
import { ViewProps } from './types';
import SubNavigation from '../sub-navigation';

const TripSecondaryAppbarView = ({
  tripMatch,
  partner,
  tabs,
}: ViewProps) => (
  <SubNavigation
    profile={{
      primary: partner ? partner.name : <Skeleton width={150} />,
    }}
    startAdornment={(
      <BackButton
        data-e2e="ztest-trip-match-back"
        defaultPath={`/trip-requests/${tripMatch?.tripRequestId}`}
        options={{
          replace: true,
        }}
        edge="start"
      >
        <OutlinedIcons.OutlinedArrowSmLeftIcon color="primary" />
      </BackButton>
        )}
    tabs={tabs}
  />
);

export default TripSecondaryAppbarView;
